/*
  Favoritos (22-10-2026). Se guardan en el navegador (localStorage 'rv_favs', lista de
  handles), sin app ni cuenta: si el cliente cambia de móvil no los ve.
  - Botones: cualquier [data-rv-fav="<handle>"] (corazón de la tarjeta y de la ficha).
  - Contadores: [data-rv-fav-count]. Lista: [data-rv-fav-list] (página del Club),
    que pide /products/<handle>.js para pintar precio y foto actuales.
*/
(function () {
  var KEY = 'rv_favs';
  var MAX = 60;

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }

  function has(handle) { return read().indexOf(handle) !== -1; }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function paintButtons() {
    var list = read();
    document.querySelectorAll('[data-rv-fav]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-rv-fav')) !== -1;
      btn.classList.toggle('is-fav', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = btn.querySelector('[data-rv-fav-label]');
      var text = on ? 'Guardado en favoritos' : 'Guardar en favoritos';
      // Solo si cambia: reescribir el texto dispararía el MutationObserver de abajo en bucle.
      if (label && label.textContent !== text) label.textContent = text;
    });
    document.querySelectorAll('[data-rv-fav-count]').forEach(function (el) {
      if (el.textContent !== String(list.length)) el.textContent = list.length;
    });
  }

  var toastTimer;
  function toast(added) {
    var el = document.getElementById('rv-fav-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'rv-fav-toast';
      el.className = 'rv-fav-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.innerHTML = added
      ? '<span>&#10084; Guardado en favoritos</span><a href="' + root() + 'pages/club#favoritos">Ver mis favoritos</a>'
      : '<span>Quitado de favoritos</span>';
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    var added = i === -1;
    if (added) list.unshift(handle); else list.splice(i, 1);
    write(list);
    paintButtons();
    renderList();
    return added;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rv-fav]');
    if (btn) {
      e.preventDefault();
      var added = toggle(btn.getAttribute('data-rv-fav'));
      if (!btn.closest('[data-rv-fav-list]')) toast(added);
      return;
    }
    var remove = e.target.closest('[data-rv-fav-remove]');
    if (remove) {
      e.preventDefault();
      toggle(remove.getAttribute('data-rv-fav-remove'));
    }
  });

  function money(cents) {
    return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function imgUrl(src, width) {
    if (!src) return '';
    try {
      var u = new URL(src, location.href);
      u.searchParams.set('width', width);
      return u.toString();
    } catch (e) {
      return src;
    }
  }

  var cache = {};
  function fetchProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root() + 'products/' + encodeURIComponent(handle) + '.js')
        // 404 = producto borrado o despublicado ('gone'); cualquier otro fallo (red, 429)
        // devuelve null y el favorito se conserva para la próxima vez.
        .then(function (r) { return r.ok ? r.json() : (r.status === 404 ? 'gone' : null); })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function renderList() {
    var box = document.querySelector('[data-rv-fav-list]');
    if (!box) return;
    var section = box.closest('[data-rv-favs]');
    var empty = section && section.querySelector('[data-rv-fav-empty]');
    var list = read();

    if (section && section.hasAttribute('data-rv-favs-optional')) section.hidden = list.length === 0;
    if (empty) empty.hidden = list.length > 0;
    if (!list.length) { box.innerHTML = ''; return; }

    Promise.all(list.map(fetchProduct)).then(function (products) {
      var gone = [];
      box.innerHTML = products.map(function (p, i) {
        if (p === 'gone') { gone.push(list[i]); return ''; }
        if (!p) return '';
        var url = root() + 'products/' + p.handle;
        return '<article class="rv-fav">' +
          '<a class="rv-fav__img" href="' + url + '">' +
            (p.featured_image ? '<img src="' + esc(imgUrl(p.featured_image, 300)) + '" alt="' + esc(p.title) + '" loading="lazy" width="150" height="150">' : '') +
          '</a>' +
          '<div class="rv-fav__body">' +
            '<a class="rv-fav__title" href="' + url + '">' + esc(p.title) + '</a>' +
            '<span class="rv-fav__price">' + money(p.price) + (p.available ? '' : ' · Agotado') + '</span>' +
            '<a class="rv-fav__link" href="' + url + '">Ver producto</a>' +
          '</div>' +
          '<button type="button" class="rv-fav__remove" data-rv-fav-remove="' + esc(p.handle) + '" aria-label="Quitar ' + esc(p.title) + ' de favoritos">&times;</button>' +
        '</article>';
      }).join('');
      // Productos borrados o despublicados: fuera de la lista.
      if (gone.length) write(read().filter(function (h) { return gone.indexOf(h) === -1; }));
      paintButtons();
    });
  }

  // Las tarjetas que llegan después (paginado de la portada, filtros) se pintan al aparecer.
  var pending;
  new MutationObserver(function () {
    clearTimeout(pending);
    pending = setTimeout(paintButtons, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { paintButtons(); renderList(); }
  });

  paintButtons();
  renderList();
})();
